import * as ActionTypes from './actionTypes';

export const actionGetMarketingPromotionList = (payload) => ({
  type: ActionTypes.GET_MARKETING_PROMOTION_LIST,
  payload,
});

export const actionGetMarketingPromotionListSuccess = (payload) => ({
  type: ActionTypes.GET_MARKETING_PROMOTION_LIST_SUCCESS,
  payload,
});

export const actionGetMarketingPromotionListFailed = (payload) => ({
  type: ActionTypes.GET_MARKETING_PROMOTION_LIST_FAILED,
  payload,
});

export const actionGetMarketingPromotionDetail = (payload) => ({
  type: ActionTypes.GET_MARKETING_PROMOTION_DETAIL,
  payload,
});

export const actionGetMarketingPromotionDetailSuccess = (payload) => ({
  type: ActionTypes.GET_MARKETING_PROMOTION_DETAIL_SUCCESS,
  payload,
});

export const actionGetMarketingPromotionDetailFailed = (payload) => ({
  type: ActionTypes.GET_MARKETING_PROMOTION_DETAIL_FAILED,
  payload,
});

export const actionCreateMarketingPromotion = (payload) => ({
  type: ActionTypes.CREATE_MARKETING_PROMOTION,
  payload,
});

export const actionCreateMarketingPromotionSuccess = (payload) => ({
  type: ActionTypes.CREATE_MARKETING_PROMOTION_SUCCESS,
  payload,
});

export const actionCreateMarketingPromotionFailed = (payload) => ({
  type: ActionTypes.CREATE_MARKETING_PROMOTION_FAILED,
  payload,
});

export const actionUpdateMarketingPromotion = (payload) => ({
  type: ActionTypes.UPDATE_MARKETING_PROMOTION,
  payload,
});

export const actionUpdateMarketingPromotionSuccess = (payload) => ({
  type: ActionTypes.UPDATE_MARKETING_PROMOTION_SUCCESS,
  payload,
});

export const actionUpdateMarketingPromotionFailed = (payload) => ({
  type: ActionTypes.UPDATE_MARKETING_PROMOTION_FAILED,
  payload,
});

export const actionDeleteMarketingPromotion = (payload) => ({
  type: ActionTypes.DELETE_MARKETING_PROMOTION,
  payload,
});

export const actionDeleteMarketingPromotionSuccess = (payload) => ({
  type: ActionTypes.DELETE_MARKETING_PROMOTION_SUCCESS,
  payload,
});

export const actionDeleteMarketingPromotionFailed = (payload) => ({
  type: ActionTypes.DELETE_MARKETING_PROMOTION_FAILED,
  payload,
});
